/* eslint linebreak-style: ["error", "windows"] */
/* eslint-enable no-unused-vars */
/*
Auditrail Cambio 6100 bsales 16/08/2022
-Se modifica el evento de submit para que haga la petición al nuevo endpoint de infousuario
*/


import React, { useState, useRef } from 'react';
import {
  Alert,
  Spinner,
  Modal,
  Button,
  Form,
} from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import {
  login,
  login1,
  infousuario,
  logout,
  infoPidm,
  getUserPidm,
} from '../services/login';
import '../assets/css/login_user.css';

function Login_user() {
  const [errorlogin, setErrorlogin] = useState(false);
  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const handleClose = () => { setSpinner(false); setShow(false); };
  const handleShow = () => { setSpinner(true); setShow(true); };

  logout();

  const [captcha, setCaptcha] = useState('');
  const recaptchaRef = React.createRef();
  //const [loading, setLoading] = useState(false);

  function validateForm() {
    if (process.env.REACT_APP_HORUM_ENV !== 'LOCAL') {
      //console.log(process.env.REACT_APP_HORUM_ENV + "_PROD");
      return usuario.length > 0 && contrasena.length > 0 && captcha.length > 0;
    }
    //console.log(process.env.REACT_APP_HORUM_ENV);
    return usuario.length > 0 && contrasena.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    const recaptchaValue = recaptchaRef.current.getValue();  //Sin ReCAPTCHA 
    setCaptcha("");
    if (recaptchaValue) {
      if (await login(usuario, contrasena, recaptchaValue)) { //Con ReCAPTCHA
        //console.log('LOGEADO');
        // AV
        if (!await infoPidm(usuario.toLowerCase())) {
          setErrorlogin(true);
        }

        if (await infousuario(getUserPidm())) {
          history.push('/mihorario/inicio');
        } else {
          setErrorlogin(true);
        }
      } else {
        //console.log('NO LOGEADO usuario o clave incorrecto');
        setErrorlogin(true);
      }
      handleClose();
    }
  }
  async function handleSubmitSincaptcha(event) {
    event.preventDefault();
    if (await login1(usuario, contrasena)) { /* Sin ReCAPTCHA */
      /* console.log('LOGEADO'); */
      /* AV */
      if (!await infoPidm(usuario.toLowerCase())) {
        setErrorlogin(true);
      }
      if (await infousuario(getUserPidm())) {
        history.push('/mihorario/inicio');
      } else {
        setErrorlogin(true);
      }
    } else {
      /* console.log('NO LOGEADO usuario o clave incorrecto'); */
      setErrorlogin(true);
    }
    handleClose();
  }
//<Form onSubmit={ process.env.REACT_APP_HORUM_ENV !== 'LOCAL' ? handleSubmit : handleSubmitSincaptcha }>
console.log('Valor de REACT_APP_HORUM_ENV:', process.env.REACT_APP_HORUM_ENV);
  return (      
    <Form onSubmit={
      process.env.REACT_APP_HORUM_ENV === 'LOCAL' 
        ? handleSubmitSincaptcha 
        : handleSubmit
      } >            
      {errorlogin && <Alert className="text-center" variant="danger">Usuario o contraseña incorrecta.</Alert>}
      <Form.Group size="lg" controlId="usuario">
        <Form.Label>Usuario</Form.Label>
        <Form.Control
          autoFocus
          type="text"
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
        />
      </Form.Group>
      <Form.Group size="lg" controlId="contrasena">
        <Form.Label>Contraseña</Form.Label>
        <Form.Control
          type="password"
          value={contrasena}
          onChange={(e) => setContrasena(e.target.value)}
        />
      </Form.Group>

      {(process.env.REACT_APP_HORUM_ENV !== 'LOCAL') ? <div id="captcha"><ReCAPTCHA ref={recaptchaRef} sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY} onChange={(e) => setCaptcha(recaptchaRef.current.getValue())} /></div> : ""}

      <Button id={'btn_login'} onClick={handleShow} block size="lg" type="submit" disabled={!validateForm()}>
        Ingresar
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Espere</Modal.Title>
        </Modal.Header>
        <Modal.Body>Cargando datos!
        </Modal.Body>
        <Modal.Footer>
          {spinner && <Spinner
            as="span"
            animation="border"
            size="lg"
            role="status"
            aria-hidden="true"
            variant="primary"
          />}
        </Modal.Footer>
      </Modal>
      <div className='d-flex justify-content-center'>
        {/* <Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true">
      <span className="visually-hidden"></span> </Spinner> */}
      </div>
    </Form>
  );
}

export default Login_user;
